import { Phone } from "lucide-react";
import { useLocaleState, useTranslate } from "ra-core";

import { formatDay } from "./projectUtils";

type Props = {
  number?: string | null;
  method?: "site" | "manual" | null;
  sourceUrl?: string | null;
  foundAt?: string | null;
  // Sur la carte d'une personne : « Standard de la société ».
  onContact?: boolean;
};

/** Standard d'une société, avec d'où il vient (règle de traçabilité) : lu sur son site, ou saisi à la main. */
export const CompanyPhone = ({
  number,
  method,
  sourceUrl,
  foundAt,
  onContact = false,
}: Props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  // Un numéro sans provenance n'est pas montré.
  if (!number || !method) return null;
  return (
    <div
      className="text-xs text-muted-foreground flex flex-wrap items-center gap-x-1"
      title={translate("resources.projects.switchboard.help")}
    >
      <Phone className="h-3 w-3" />
      <span>
        {translate(
          `resources.projects.switchboard.${onContact ? "contact" : "label"}`,
        )}
      </span>
      <a
        href={`tel:${number.replace(/[^\d+]/g, "")}`}
        className="underline hover:no-underline"
      >
        {number}
      </a>
      <span>
        · {translate(`resources.projects.switchboard.found.${method}`)}
        {foundAt &&
          ` ${translate("resources.projects.site.on", { date: formatDay(foundAt, locale ?? "fr") })}`}
      </span>
      {sourceUrl && (
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:no-underline"
        >
          · {translate("resources.projects.site.source")}
        </a>
      )}
    </div>
  );
};
